import { createSlice } from "@reduxjs/toolkit";
import { nonprofitMediaAPI, uploadNonprofitMediaAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const nonprofitMediaSlice = createSlice({
  name: "nonprofitMedia",
  initialState: data,
  reducers: {
    nonprofitMediaSlice(state) {
      state.isLoading = true;
    },
    nonprofitMediaSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    uploadNonprofitMediaSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    nonprofitMediaSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    nonprofitMediaSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const nonprofitMediaHandler = (org_id:string) => async (dispatch: any) => {
  try {
    dispatch(nonprofitMediaAction.nonprofitMediaSlice());
    const response: any = await nonprofitMediaAPI(org_id);
    dispatch(nonprofitMediaAction.nonprofitMediaSliceSuccess(response));
  } catch (e: any) {
    dispatch(nonprofitMediaAction.nonprofitMediaSliceFailure(e?.response?.data?.message));
    dispatch(nonprofitMediaAction.nonprofitMediaSliceReset());
  }
};
export const uploadNonprofitMediaHandler = (org_id:string,body:any) => async (dispatch: any) => {
  try {
    dispatch(nonprofitMediaAction.nonprofitMediaSlice());
    const response: any = await uploadNonprofitMediaAPI(org_id,body);
    dispatch(nonprofitMediaAction.uploadNonprofitMediaSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(nonprofitMediaAction.nonprofitMediaSliceFailure(e?.response?.data?.message));
    dispatch(nonprofitMediaAction.nonprofitMediaSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default nonprofitMediaSlice.reducer;
export const nonprofitMediaAction = nonprofitMediaSlice.actions;
